import * as React from "react";
import { FaCreditCard } from "react-icons/fa";
import { styled } from "../../styled";
import { UnionPayLogo, AmericanExpressLogo, DinersClubLogo, DiscoverLogo, JcbLogo, MastercardLogo, VisaLogo, } from "../icons/logos";
const Icon = styled("div") `
	font-size: 50px;
	color: ${({ theme }) => theme.color.primary};
`;
export const CreditCardIcon = (props) => {
    switch (props.card_brand) {
        case "amex":
            return React.createElement(AmericanExpressLogo, null);
        case "diners":
            return React.createElement(DinersClubLogo, null);
        case "discover":
            return React.createElement(DiscoverLogo, null);
        case "jcb":
            return React.createElement(JcbLogo, null);
        case "mastercard":
            return React.createElement(MastercardLogo, null);
        case "unionpay":
            return React.createElement(UnionPayLogo, null);
        case "visa":
            return React.createElement(VisaLogo, null);
        case "unknown":
            return (React.createElement(Icon, { style: { fontSize: "50px" } },
                React.createElement(FaCreditCard, null)));
        default:
            return React.createElement(React.Fragment, null, " ");
    }
};
export const PaymentCardMobileIcon = () => (React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M16.6665 6.66671H3.33317V5.00004H16.6665M16.6665 15H3.33317V10H16.6665M16.6665 3.33337H3.33317C2.40817 3.33337 1.6665 4.07504 1.6665 5.00004V15C1.6665 15.4421 1.8421 15.866 2.15466 16.1786C2.46722 16.4911 2.89114 16.6667 3.33317 16.6667H16.6665C17.1085 16.6667 17.5325 16.4911 17.845 16.1786C18.1576 15.866 18.3332 15.4421 18.3332 15V5.00004C18.3332 4.55801 18.1576 4.13409 17.845 3.82153C17.5325 3.50897 17.1085 3.33337 16.6665 3.33337Z", fill: "#6B7270" })));
//# sourceMappingURL=credit-card-logo.js.map